import { TopToolbar, useListContext, usePermissions } from "react-admin";
import CustomExportButton from "../../unit/CustomExportButton";
import CustomFilterButton from "../../unit/CustomFilterButton";
import HmPageHeaderTitle from "../../unit/HmPageHeaderTitle";
import { ShowListTotal } from "../../unit/ShowListTotal";
import { Typography } from "@mui/material";

const ApplicationListTitle = () => {
  const listContext = useListContext();
  const { filterValues } = listContext;

  let showApplicationTitle = "Applications";
  if (filterValues.status == "New") {
    showApplicationTitle = "New";
  } else if (filterValues.status == "Hold") {
    showApplicationTitle = "Hold";
  } else if (filterValues.status == "Initial Review") {
    showApplicationTitle = "Initial Review";
  } else if (filterValues.status == "Final Review") {
    showApplicationTitle = "Final Review";
  } else if (filterValues.status == "To Notify") {
    showApplicationTitle = "Notification";
  } else if (filterValues.status == "Countered") {
    showApplicationTitle = "Countered";
  } else if (filterValues.status == "Approved") {
    showApplicationTitle = "Approved";
  } else if (filterValues.status == "Declined") {
    showApplicationTitle = "Declined";
  } else if (filterValues.status == "Pre-Approved") {
    showApplicationTitle = "Pre-Approved";
  } else if (filterValues.status == "Expired") {
    showApplicationTitle = "Expired";
  } else if (filterValues.status == "Incomplete") {
    showApplicationTitle = "Incompleted";
  }

  return (
    <HmPageHeaderTitle
      title={showApplicationTitle}
      totalNumber={<ShowListTotal onlyShowNumber={true} />}
    />
  );
};

const ApplicationListActions = () => {
  const { permissions } = usePermissions();
  const { total, data, isPending, isLoading, isFetching } = useListContext();
  if (isPending) return null;
  return (
    <TopToolbar sx={{ width: "100%" }}>
      <CustomFilterButton />
      <CustomExportButton />
    </TopToolbar>
  );
};

export default ApplicationListActions;
